import { COUNTRIES } from "./components/PlaceAutocomplete";

// Shared meaning of the search box and the continent filter across the app.

export const CONTINENTS = ["África", "América Central", "América del Norte", "América del Sur", "Asia", "Europa", "Oceanía"];

// ISO 3166 codes per continent. The Caribbean counts as América del Norte.
const CONTINENT_CODES = {
  África:
    "DZ AO BJ BW BF BI CV CM CF TD KM CG CD CI DJ EG GQ ER SZ ET GA GM GH GN GW KE LS LR LY MG MW ML MR MU YT MA MZ NA NE NG RE RW SH ST SN SC SL SO ZA SS SD TZ TG TN UG EH ZM ZW",
  "América Central": "BZ CR SV GT HN NI PA",
  "América del Norte":
    "AI AG AW BS BB BM BQ VG CA KY CU CW DM DO GL GD GP HT JM MQ MX MS PR BL KN LC MF PM VC SX TT TC US VI UM",
  "América del Sur": "AR BO BR CL CO EC FK GF GY PY PE SR UY VE GS",
  Asia:
    "AF AM AZ BH BD BT BN KH CN CY GE HK IN ID IR IQ IL JP JO KZ KW KG LA LB MO MY MV MN MM NP KP OM PK PS PH QA SA SG KR LK SY TW TJ TH TL TR TM AE UZ VN YE IO CC CX",
  Europa:
    "AX AL AD AT BY BE BA BG HR CZ DK EE FO FI FR DE GI GR GG VA HU IS IE IM IT JE XK LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SJ SE CH UA GB",
  Oceanía: "AS AU CK FJ PF GU KI MH FM NR NC NZ NU NF MP PW PG PN WS SB TK TO TV VU WF",
};

const CONTINENT_BY_CODE = Object.fromEntries(
  Object.entries(CONTINENT_CODES).flatMap(([continent, codes]) =>
    codes.split(" ").map((code) => [code, continent])
  )
);

export const normalize = (text = "") =>
  String(text).normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

const CODE_BY_COUNTRY = Object.fromEntries(COUNTRIES.map((c) => [normalize(c.name), c.code]));

/** Continent of a listing, from its country (saved by Publicar) or, for old listings, its free-text "Lugar". */
export const continentOf = (place) => {
  const byCountry = CONTINENT_BY_CODE[CODE_BY_COUNTRY[normalize(place.country)]];
  if (byCountry) return byCountry;
  const lugar = normalize(place.place);
  return CONTINENTS.find((c) => lugar.includes(normalize(c))) || null;
};

/** True when every word typed appears in the listing's name, address, city, province or country. */
export const matchesSearch = (place, query) => {
  const words = normalize(query).split(/\s+/).filter(Boolean);
  if (!words.length) return true;
  const haystack = normalize(
    [place.title, place.name, place.address, place.city, place.province, place.country, place.place]
      .filter(Boolean)
      .join(" ")
  );
  return words.every((w) => haystack.includes(w));
};

/** Listings that pass both the search box and the continent filter ("" = all). */
export const filterPlaces = (places, query, continent) =>
  places.filter((p) => matchesSearch(p, query) && (!continent || continentOf(p) === continent));
